import { Controller } from "@hotwired/stimulus"

export default class BuzzerSoundController extends Controller {
  static values = { src: String }

  declare srcValue: string

  connect(): void {
    const audio = new Audio(this.srcValue)
    audio.play().catch((e) => { console.warn("[buzzer-sound] Audio play failed:", e.message || e) })
    this.element.remove()
  }
}
